import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Navbar from "../../Utils/Navbar/navbar-component";
import Toast from "../../Utils/Toast/toast-component";
import * as authActions from '../../Redux/Auth/AuthActions';
import notFoundImage from '../../Assets/not_found.png'
import ThemeToggler from "../../Utils/Theme/theme-toggeler-component";

// import WebsocketWorker from "../../Workers/WebsocketWorker";

function NotFound() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleRedirect = async (e) => {
        e.preventDefault();
        let path = e.target.value;
        const redirectPath = path || '/home';
        dispatch(authActions.redirectScreen(redirectPath))
        navigate(redirectPath);
    }

    return (
        <div>
            <Toast></Toast>
            <div className="min-h-full w-full">
                <Navbar />
                <header className="">
                    <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
                        {/* <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-50">Comming Soon</h1> */}
                    </div>
                </header>

                <main>
                    <div className="flex justify-center content-center mx-auto max-w-7xl sm:px-6 lg:px-8 ">
                        <div className="flex bg-white dark:bg-black rounded-3xl">
                            <div className="flex py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                                <div className="flex justify-center content-center items-center flex-col mx-auto max-w-screen-sm text-center">
                                    <h1 className="mb-4 text-6xl tracking-tight font-extrabold lg:text-6xl text-blue-600 dark:text-blue-500">404 Not Found</h1>
                                    <div className="flex w-1/2 justify-center align-middle">
                                        <img src={notFoundImage} alt="landing" />
                                    </div>
                                    <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">Something's missing.</p>
                                    <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">Sorry, we can't find that page. You'll find lots to explore on the home page. </p>
                                    <button className="button-component" onClick={handleRedirect}>Back to homepage</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}

export default NotFound;